// Tab-bar launcher for the on-demand "system" sections (Forms / Imports /
// Sessions / Users / Audit). Clicking an item opens (or focuses) that section as
// a closable top tab — see Shell.jsx. Reuses the ExportMenu dropdown styling +
// the shared outside-click/Escape hook.
//
// The dropdown is rendered through a Portal with position:fixed, anchored to the
// button's rect — the tab bar uses overflow-x:auto (so tabs can scroll), which
// also clips overflow-y, so an in-flow popover would be cut off. Portalling to
// <body> escapes that clip.
//
// Props:
//   items   [{ id, label, icon, open }]  — already role-filtered by the caller
//   onPick  (id) => void
import { createSignal, Show, For } from 'solid-js';
import { Portal } from 'solid-js/web';
import { useDismissable } from '../lib/dismissable.js';

export default function OpenMenu(props) {
  const [open, setOpen] = createSignal(false);
  const [pos, setPos] = createSignal({ top: 0, left: 0 });
  let btnRef, menuRef;
  useDismissable(() => [btnRef, menuRef], () => setOpen(false), { event: 'click' });

  const toggle = () => {
    if (!open() && btnRef) {
      const r = btnRef.getBoundingClientRect();
      setPos({ top: Math.round(r.bottom + 4), left: Math.round(r.left) });
    }
    setOpen(!open());
  };
  const pick = (id) => { setOpen(false); props.onPick?.(id); };

  return (
    <div class="export-menu open-menu">
      <button ref={btnRef} class="tab open-menu-btn" classList={{ active: open() }}
              onClick={toggle} title="Open a section">
        ☰ Open ▾
      </button>
      <Show when={open()}>
        <Portal>
          <div ref={menuRef} class="export-menu-pop open-menu-pop"
               style={`top:${pos().top}px; left:${pos().left}px;`}>
            <For each={props.items}>
              {(it) => (
                <button class="export-menu-item open-menu-item" onClick={() => pick(it.id)}>
                  <span class="open-menu-icon">{it.icon}</span>
                  <span>{it.label}</span>
                  <Show when={it.open}><span class="open-menu-dot" title="Already open">●</span></Show>
                </button>
              )}
            </For>
          </div>
        </Portal>
      </Show>
    </div>
  );
}
